// export const environment = {
//   production: false,

//   eth: {
//     chainId: '0xaa36a7', //hexadecimal for metamask
//     chainIdInt: 11155111,
//     chainName: 'Ethereum Mainnet',
//     gasFees: 0,
//     purchaseToken: 'ETH',
//     hasStaking: true,
//     nativeFunction: 'buyWithEth',
//     multicall: '0xca11bde05977b3631167028862be2a173976ca11',
//     presaleAddress: '0xe77864E6368103da3E0C3f86781456Af1a10Ee3A',
//     usdTAddress: '0x9fa2AE3c0a571BbBFd17E74d7470b6c444A87aF2',
//     usdcAddress: '0x232331e4e45582742A2D717562Cd682fA132b799',
//     rpcURL: '',
//     backupRPC: '',
//     blockExplorerURL: 'https://etherscan.io/tx/',
//     chainInfo: {
//       method: 'wallet_addEthereumChain',
//       params: [
//         {
//           chainId: '0xaa36a7',
//           chainName: 'Ethereum Mainnet',
//           nativeCurrency: {
//             name: 'ETH',
//             symbol: 'ETH',
//             decimals: 18,
//           },
//           rpcUrls: ['https://rpc.ankr.com/eth'],
//           blockExplorerUrls: ['https://etherscan.io/'],
//         },
//       ],
//     },
//   },

//   bsc: {
//     chainId: '0x61', //hexadecimal for metamask
//     chainIdInt: 97,
//     chainName: 'BSC Mainnet',
//     gasFees: 0,
//     purchaseToken: 'BNB',
//     hasStaking: false,
//     nativeFunction: 'buyWithBNB',
//     presaleAddress: '0x29366e4F643A521f7874F4c4cFf88Aa8c4643A1e',
//     multicall: '0xca11bde05977b3631167028862be2a173976ca11',
//     usdTAddress: '0xADFc9B54FB7a1677176A7529F03b91081C91355c',
//     usdcAddress: '0xF4053F70d6cC72C0473F2a9E42176DB818D24454',
//     rpcURL: '',
//     backupRPC: '',
//     blockExplorerURL: 'https://bscscan.com/tx/',
//     chainInfo: {
//       method: 'wallet_addEthereumChain',
//       params: [
//         {
//           chainId: '0x61',
//           chainName: 'BSC Mainnet',
//           nativeCurrency: {
//             name: 'BNB',
//             symbol: 'BNB',
//             decimals: 18,
//           },
//           rpcUrls: ['https://bsc-dataseed.binance.org'],
//           blockExplorerUrls: ['https://bscscan.com/'],
//         },
//       ],
//     },
//   },

//   minToken: 0,
//   stakingAddress: '0xE907183A1F9250efe279bc2Dd149357EbBA123D2',
//   apyCalcConst: '416666667',
//   tokenAddress:     '0x93aA0ccD1e5628d3A841C4DbdF602D9eb04085d6',
//   stakeUnlockTime: 1912943476000,
//   tokenName: '$PEPU',
//   walletConnectId: 'dcc6d18b5082c57305a72c6ea1026e01',
//   iidDashFx: 0,
//   urlDashFx: '',
//   wertOrigin: 'https://sandbox.wert.io', // testnet
//   partnerId: '01HK57C8XMFEVRTMAW55NBD9W2', // testnet
//   wertUrl: 'https://ijs2jkwmnzohnnjppqkypl2avq0hhlcm.lambda-url.eu-west-2.on.aws/', // testnet
//   referUrl: 'https://fztdp5he4ueq4nytzyj2ycx7vm0wwqth.lambda-url.eu-west-2.on.aws/',
//   bwUniversalLink: 'https://best-wallet-dev.web.app',
//   bwDeepLink: 'bw-dev://app/connect?',
//   bwApiUrl: 'https://d19yvvzbif6vnj.cloudfront.net/webhook-service-api/presale',
//   showBestWallet: false,
//   domain: 'https://pepeunchained.com', // replace with live site URL
//   sseUrl: '',
//   notificationTimeout: 7000,
//   presaleName: 'pepeunchained',
//   presale_singular_link: '',
//   post_presale_singular_link: '',
//   wertOnRampUrl: '', //will change according to the presales.
// };


export const environment = {
  production: true,

 eth: {
    chainId: '0x1', //hexadecimal for metamask
    chainIdInt: 1,
    chainName: 'Ethereum Mainnet',
    gasFees: 0.005,
    purchaseToken: 'ETH',
    hasStaking: true,
    nativeFunction: 'buyWithEth',
    presaleAddress: '0xe77864E6368103da3E0C3f86781456Af1a10Ee3A',
    usdcAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    usdTAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    rpcURL: 'https://weathered-proud-shadow.quiknode.pro/834718d356f9aceb79e8aa2985231ce7958ff77b/',
    backupRPC: 'https://spring-cool-layer.quiknode.pro/1232079ec3115f3240687d54846d6c9d3234fe8f/',
    // rpcURL: 'https://spring-cool-layer.quiknode.pro/1232079ec3115f3240687d54846d6c9d3234fe8f/',
    // backupRPC: 'https://spring-cool-layer.quiknode.pro/1232079ec3115f3240687d54846d6c9d3234fe8f/',
    blockExplorerURL: 'https://etherscan.io/tx/',
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainId: '0x1',
          chainName: 'Ethereum Mainnet',
          nativeCurrency: {
            name: 'ETH',
            symbol: 'ETH',
            decimals: 18,
          },
          rpcUrls: ['https://rpc.ankr.com/eth'],
          blockExplorerUrls: ['https://etherscan.io/'],
        },
      ],
    },
  },

  bsc: {
    chainId: '0x38', //hexadecimal for metamask
    chainIdInt: 56,
    chainName: 'BSC Mainnet',
    gasFees: 0.0025,
    purchaseToken: 'BNB',
    hasStaking: false,
    nativeFunction: 'buyWithBNB',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    presaleAddress: '0x000000000000000000000000',
    usdTAddress: '0x000000000000000000000000',
    usdcAddress: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    rpcURL: '',
    backupRPC: '',
    blockExplorerURL: 'https://bscscan.com/tx/',
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainId: '0x38',
          chainName: 'BSC Mainnet',
          nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18,
          },
          rpcUrls: ['https://bsc-dataseed.binance.org'],
          blockExplorerUrls: ['https://bscscan.com/'],
        },
      ],
    },
  },

  minToken: 10,
  stakingAddress:   '0x72aDE8FD2De8C6A7DE741537E5860380EDDC002B',
  tokenName: '$PEPU',
  tokenAddress:     '0x93aA0ccD1e5628d3A841C4DbdF602D9eb04085d6',
  stakeUnlockTime: 0,
  iidDashFx: 0,
  urlDashFx: '',
  wertOrigin: 'https://widget.wert.io', // mainnet
  partnerId: '', // mainnet
  wertUrl: '', // mainnet
  walletConnectId: 'cf8df9d85cae0f132b3f6a1813ea01f2',
  apyCalcConst: 1600000000,
  referUrl: '',
  bwUniversalLink: 'https://best-wallet-prod.web.app',
  bwDeepLink: 'bw://app/connect?',
  bwApiUrl: 'https://api.bestwallet.com/presale-transactions',
  showBestWallet: false,
  domain: 'https://pepeunchained.com', // replace with live site URL
  sseUrl: '',
  notificationTimeout: 7000,
  presaleName: 'pepeunchained',
  presale_singular_link: '',
  post_presale_singular_link: '',
  wertOnRampUrl: '', //will change according to the presales.
};